import { TopBar } from './dumb.js';
import enhance from './enhancer';

export default enhance(TopBar);
